module.exports = __webpack_public_path__ + "media/ladebildschirm.511d9a00.mp3";